export var HeartbeatSignal;
(function (HeartbeatSignal) {
    HeartbeatSignal["Ping"] = "ping";
    HeartbeatSignal["Pong"] = "pong";
})(HeartbeatSignal || (HeartbeatSignal = {}));
